// A duration that keeps counting while it's still running (no end time yet):
// re-renders itself once a second instead of waiting for the next data
// refresh, and stops ticking as soon as an end time arrives.

import { useEffect, useState } from 'react'
import { formatDuration } from '../lib/format'

export function LiveDuration({ startedAt, endedAt }: { startedAt: string | null | undefined; endedAt?: string | null }) {
  const running = !!startedAt && !endedAt
  const [, setTick] = useState(0)
  useEffect(() => {
    if (!running) return
    const timer = setInterval(() => setTick((t) => t + 1), 1000)
    return () => clearInterval(timer)
  }, [running])
  return <span className="tabular-nums">{formatDuration(startedAt, endedAt)}</span>
}
